module.exports = __webpack_public_path__ + "static/media/auth-google-play.26ed2ee1.svg";